import React from "react";

import FooterC from "../components/FooterC";
import NavbarCandidate from "../components/NavbarCandidate";

function Candidate({ children }) {
  return (
    <div id="wrapper">
      <div className="d-flex flex-column content-candidate">
        <div id="content">
          <NavbarCandidate />

          <div
            className="container-fluid"
            style={{
              minHeight: "calc(100vh - 120px)",
            }}
          >
            {children}
          </div>
        </div>

        <FooterC />
      </div>
    </div>
  );
}

export default Candidate;
